/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RegisterResult {
    NotFound = 0,
    Occupied = 1,
    Success = 2,
    RecordingNotFound = 3,
}
